import { Theme } from '../../../../jss';

export const ToolTipClassBase = (theme: Theme) => {
  return {
    '& .tip-message': {
      fontFamily: theme.typography.mainFontFamily,
    },

    '& .tip-message.tip-hint': {
      color: theme.palette.primaryTextColor,
    },

    '& .tip-message.tip-warning': {
      color: theme.palette.warningTextColor,
    },

    '& .tip-message.tip-error': {
      color: theme.palette.invalidTextColor,
    },

    '& .tip-message.tip-success': {
      color: theme.palette.validTextColor,
    },
  };
};
